import React from 'react';
import '../styles/TemplateCard.css';
import {Badge} from "./Badge";
interface TemplateCardProps {
    name: string;
    imageUrl?: string;
    imageUrlHover?: string;
    categories?: string[];
    price: string;
    link: string;
    index : number;
    badge? : string;
    badgeClass? : string
}

export const TemplateCard: React.FC<TemplateCardProps> = ({
                                                              name,
                                                              imageUrl = undefined,
                                                              imageUrlHover = undefined,
                                                              categories = undefined,
                                                              price = "$0",
                                                              link = "",
                                                              badge = undefined,
                                                              index = 1,
                                                              badgeClass = undefined,
                                                          }) => {

    let categoriesAndPrice : string[] = [];

    if(categories) {
        categoriesAndPrice.push(categories.join(", "));
    }
    categoriesAndPrice.push(price)

    const categoriesAndPriceString = categoriesAndPrice.join(" · ");

    function renderCardContent() {
        return <>
            {
                imageUrl ? <div className="image" style={{backgroundImage: "url(" + imageUrl + ")"}}></div> :
                    <div className="empty-bg">
                        <div className="empty-label font-body-M">Coming soon...</div>
                    </div>
            }
            {
                imageUrlHover ?
                    <div className="image hover" style={{backgroundImage: "url(" + imageUrlHover + ")"}}></div> :
                    <div className="empty-bg">
                        <div className="empty-label font-body-M">Coming soon...</div>
                    </div>
            }
            <svg width="148" height="127" viewBox="0 0 148 127" className="corner" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M148 82.2002C148 97.8815 148 105.722 144.948 111.712C142.264 116.98 137.98 121.264 132.712 123.948C126.722 127 118.882 127 103.2 127H0C15.464 127 28 114.464 28 99V44.7998C28 29.1185 28 21.2776 31.0518 15.2881C33.7362 10.0196 38.0196 5.7362 43.2881 3.05176C49.2776 -4.74688e-05 57.1185 0 72.7998 0H148V82.2002Z"
                    fill="#111111"/>
            </svg>

            <div className="circle-with-arrow">
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 17.3809L17.5 7.38086" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                    <path d="M7.5 7.38086H17.5V17.3809" stroke="white" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            </div>
        </>
    }

    return (
        <div className={"template-card animate-from-bottom " + "delay-" + ((index) % 9 + 1)}>
            {
                link ?
                    <a href={link} target="_blank" className={"card-content" + (link ? " has-link" : "")}>
                        {
                            renderCardContent()
                        }
                    </a> :
                    <div className={"card-content"}>
                    {
                            renderCardContent()
                        }
                    </div>
            }
            <div className="card-props">
                <h5>{name}</h5>
                {
                    badge ? <Badge className={badgeClass}>{badge}</Badge> : undefined
                }
                {categoriesAndPriceString && <div className="categories-and-price">{categoriesAndPriceString}</div>}
            </div>
        </div>
    );
};
export default TemplateCard;
